import {
  Environment
} from '@vodacom/web-env';

import {
  JavascriptTypes
} from '../../../constants';

import {
  AppState
} from 'helpers';

export class TrendsProvider {

  static STATE = AppState.with('TrendsProvider');

  static async getTweets(trend) {

    return TrendsProvider.STATE.makeServiceCall(

      `${Environment.current.apiHost}/tweets?term=${trend}`,
      {
        method: 'GET',
        cacheKey: `tweets--${trend}`
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('No tweets found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      });
  }

  static async getTrends() {

    return TrendsProvider.STATE.makeServiceCall(

      `${Environment.current.apiHost}/trends/23424942`,
      {
        method: 'GET',
        cacheKey: 'trends'
      }
    )
      .then((res) => {

        if (!res.result) {

          return {
            ok: false,
            error: new Error('No trends found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {

        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      });
  }

  static async getCachedItem(key, fallback, serviceFallback) {

    const cachedItem = TrendsProvider.STATE.getItem(key, fallback);

    if (!cachedItem && serviceFallback && typeof serviceFallback === JavascriptTypes.Function) {
      const response = await serviceFallback();

      if (response.ok && response.result) {
        return response;
      }
    }

    return cachedItem;
  }
}
